export async function scanImage(data, customHeaders = {}) {
  const PATRON_SCAN_API_URL = process.env.PATRON_SCAN_API_URL
  const secretHeaders = {
    apisid: process.env.PATRON_SCAN_API_SID,
    apitoken: process.env.PATRON_SCAN_API_TOKEN,
  }

  try {
    const response = await fetch(PATRON_SCAN_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...secretHeaders,
        ...customHeaders,
      },
      body: JSON.stringify(data),
    })

    const contentType = response.headers.get('content-type')

    const isJson = contentType && contentType.includes('application/json')

    const responseBody = isJson
      ? await response.json()
      : {
          success: false,
          error: { message: await response.text(), description: await response.text() },
          status: response.status,
        }

    if (!response.ok) {
      return responseBody
    }

    return responseBody
  } catch (error) {
    return {
      success: false,
      error: { message: error.message, description: 'Error occurred please try later or try manual entering' },
    }
  }
}
